// hooks/useOpenTicket.js
import { useState } from "react";
import { ouvrirTicket } from "../lib/ticket.js";

/**
 * Fournit une fonction `openTicket(idTicket)` pour réouvrir un ticket et expose `{ openTicket, loading, error }`.
 *
 * @returns {{ openTicket: Function, loading: boolean, error: string|null }}
 */
export function useOpenTicket() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openTicket = async (idTicket) => {
    try {
      setLoading(true);
      setError(null);
      const result = await ouvrirTicket(idTicket);
      return result;
    } catch (err) {
      setError(err.message || "Erreur lors de l'ouverture du ticket."); 
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { openTicket, loading, error };
}
